import { useState, useEffect } from 'react'
import { useAppSelector } from '../../../state/hooks'
import Geocoder from 'react-native-geocoding'
import { getDistance } from 'geolib'
export const useIsFreeDeliveryEligible = () => {
	const [isSameCity, setIsSameCity] = useState(false)
	const [isWithinDistance, setIsWithinDistance] = useState(false)
	const [isLoading, setIsLoading] = useState(true)
	const { address: orgAddress } = useAppSelector(state => state.settings)
	const { userLocation } = useAppSelector(state => state.user)

	useEffect(() => {
		if (!userLocation?.longAddress || !orgAddress) {
			setIsLoading(false)
			return
		}

		const getLocationDetails = async () => {
			try {
				const [response1, response2] = await Promise.all([
					Geocoder.from(userLocation?.longAddress),
					Geocoder.from(orgAddress),
				])

				const getCity = response =>
					response.results[0].address_components.find(comp => comp.types.includes('locality'))
						?.long_name

				const deliveryCity = getCity(response1)
				const orgCity = getCity(response2)

				// Get coordinates for distance calculation
				const deliveryLocation = response1.results[0].geometry.location
				const orgLocation = response2.results[0].geometry.location

				const distance =
					getDistance(
						{ latitude: deliveryLocation.lat, longitude: deliveryLocation.lng },
						{ latitude: orgLocation.lat, longitude: orgLocation.lng }
					) / 1000 // Convert meters to kilometers

				console.log('distance', distance)

				// Batch state updates
				setIsSameCity(deliveryCity === orgCity)
				setIsWithinDistance(distance <= 8)
			} catch (error) {
				console.error('Error getting city from address:', error)
				return null
			} finally {
				setIsLoading(false)
			}
		}

		getLocationDetails()
	}, [userLocation?.longAddress, orgAddress])

	return { isFreeDeliveryEligible: isSameCity || isWithinDistance, isLoading }
}
